import { render, staticRenderFns } from "./SalonsComponent.vue?vue&type=template&id=1f9dc60c&"
import script from "./SalonsComponent.vue?vue&type=script&lang=js&"
export * from "./SalonsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports